import React from 'react';
import About from 'component/About';
import './about.css';
const AboutPage=()=>{
  return (
    <div className="about-page">
      <About />
    </div>
  );
}

export default AboutPage;
